import { render } from "./SettingsSearch.vue?vue&type=template&id=4df8b02c&scoped=true"
import script from "./SettingsSearch.vue?vue&type=script&lang=js"
export * from "./SettingsSearch.vue?vue&type=script&lang=js"

import "./SettingsSearch.vue?vue&type=style&index=0&id=4df8b02c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df8b02c"]])

export default __exports__